// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const ModelTestOut = zod.object({
  "cost_usd": zod.union([zod.string(),zod.null()]).optional(),
  "error": zod.union([zod.string(),zod.null()]).optional(),
  "latency_ms": zod.union([zod.int(),zod.null()]).optional(),
  "ok": zod.boolean(),
  "text": zod.union([zod.string(),zod.null()]).optional(),
  "tokens_input": zod.union([zod.int(),zod.null()]).optional(),
  "tokens_output": zod.union([zod.int(),zod.null()]).optional()
});

export type ModelTestOut = zod.input<typeof ModelTestOut>;
export type ModelTestOutOutput = zod.output<typeof ModelTestOut>;
